<template>
  <section id="ThankYou">
    <h3>Thank you to our Truecaller Community for a great #YearInCalling2020</h3>
    <a
      v-if="isAndroid"
      id="PersonalStats"
      href="https://tc.onelink.me/571208033/3416bd1a"
      target="_blank"
      rel="noreferrer, noopener"
      class="button button--white"
      @click="$gtag.event('clicked_personal_stats', {
        'event_category' : 'outbound',
        'event_label' : 'personal_stats'
      })"
    >
      <img src="@/assets/icons/personal-data-icon.svg">
      See your personal stats
    </a>
    <div id="ThankYouShare">
      <a
        target="_blank"
        rel="noreferrer, noopener"
        :href="tw"
        class="button button--white"
        @click="$gtag.event('clicked_share_twitter', {
          'event_category' : 'outbound',
          'event_label' : 'share_twitter'
        })"
      >
        <img
          width="24"
          height="24"
          src="@/assets/icons/twitter-share.svg"
        />
        <span>Share on &nbsp;</span>Twitter
      </a>
      <a
        target="_blank"
        rel="noreferrer, noopener"
        :href="fb"
        class="button button--white"
        @click="$gtag.event('clicked_share_facebook', {
          'event_category' : 'outbound',
          'event_label' : '_share_facebook'
        })"
      >
        <img
          width="24"
          height="24"
          src="@/assets/icons/facebook-share.svg"
        />
        <span>Share on &nbsp;</span>Facebook
      </a>
      <a
        target="_blank"
        rel="noreferrer, noopener"
        :href="wa"
        class="button button--white"
        @click="$gtag.event('clicked_share_whatsapp', {
          'event_category' : 'outbound',
          'event_label' : 'share_whatsapp'
        })"
      >
        <img
          width="24"
          height="24"
          src="@/assets/icons/whatsapp-share.svg"
        />
        <span>Share on &nbsp;</span>Whatsapp
      </a>
    </div>
    <p>The data in this article was aggregated anonymously from incoming and outgoing calls & messages during the period of January 1st, 2020 to October 31, 2020. No context of any calls or messages were read. During this period of time we helped our users identify 145 billion calls and helped identify 13.8 billion spam SMS globally.</p>

  </section>
</template>

<script>
import { ref, onMounted } from "vue";
import sharing from "@/share";
export default {
  setup() {
    const isAndroid = ref(false);
    const fb = ref(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        sharing.main.url
      )}`
    );
    const tw = ref(
      `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        sharing.main.tw + " " + sharing.main.url
      )}`
    );
    const wa = ref(
      `whatsapp://send?text=${encodeURIComponent(
        sharing.main.wa + " " + sharing.main.url
      )}`
    );
    onMounted(() => {
      if (/Android/i.test(navigator.userAgent)) {
        isAndroid.value = true;
      }
    });
    return {
      isAndroid,
      fb,
      tw,
      wa,
    };
  },
};
</script>

<style>
#ThankYou {
  background-image: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
    url("../assets/images/year_in_calling_truecaller_2020_2.png");
  background-size: cover;
  background-position: center center;
  padding: 96px 20px 48px;
}
#ThankYou h3 {
  font-size: 24px;
  line-height: 30px;
  letter-spacing: -0.72px;
  margin-bottom: 24px;
}
#ThankYou p {
  font-size: 12px;
  line-height: 20px;
  margin-top: 32px;
}
#ThankYouShare {
  display: none;
  flex-flow: column;
  justify-content: center;
}
#ThankYouShare button {
  margin: 12px auto;
}
#ThankYouShare button span {
  display: none;
}

@media screen and (min-width: 720px) {
  #ThankYou h3 {
    font-size: 42px;
    line-height: 46px;
    letter-spacing: -1.26px;
    margin-bottom: 24px;
  }
  #ThankYou p {
    font-size: 12px;
    line-height: 20px;
    margin-top: 32px;
  }
  #ThankYouShare {
    display: flex;
  }
  #ThankYouShare button span {
    display: inline;
  }

  #PersonalStats {
    display: none;
  }
}
@media screen and (min-width: 960px) {
  #ThankYouShare {
    display: flex;
    flex-flow: row;
    justify-content: center;
  }
  #ThankYouShare .button {
    margin: 48px 20px 0;
  }
}
</style>